/**
 *
 * Utils file is useful to re-use the custom utilities.
 */

import {
  ACCESS_EXPIRED,
  AUTHORIZE_PARAMS,
  CONSOLE,
  MESSAGE,
  NOT_VERIFIED,
  SOURCE,
  TEMPLATE,
  URL_EXPIRED,
  VERIFY_EMAIL
} from './../content/constants';

const isNull = (val) => val === null;

const isEmpty = (val) => val === '';
const getRoute = (prev, next) => {
  const searchParams = new URLSearchParams(window.location.search);
  const source = searchParams.get(SOURCE) || '';
  if (!source) return `/login${window.location.search}&source=${next}`;
  return `/login${window.location.search.replace(
    `source=${prev}`,
    `source=${next}`
  )}`;
};
const gtmEventTracker = (event, rest = {}) => {
  window.dataLayer.push({
    event,
    ...rest
  });
};
const factorEventTracker = (data = {}, eventType = '$form_submitted') => {
  try {
    window.factors.track(eventType, {
      $email: data.email,
      $channel_type: data.channel,
      $formType: data.formType,
      $form_submission: data.formSubmision
    });
  } catch (error) {
    console.error('Error while tracking event:', error);
  }
};
const getAuthorizeUrl = (locale) => {
  const searchParams = new URLSearchParams(window.location.search);
  const templateType = searchParams.get(TEMPLATE) || '';
  const isSource = searchParams.has(SOURCE);
  const message = searchParams.get(MESSAGE) || '';
  const isConsole = searchParams.has(CONSOLE);
  let authorizeUrl = '';
  searchParams.forEach((value, key) => {
    if (key === 'lang') {
      value = locale;
    }
    if (key === 'redirect_uri') {
      if (value.includes('lang')) {
        const [uri] = value.split('lang=');
        value = encodeURIComponent(`${uri}lang=${locale}`);
      } else {
        const updatedRedirectUrl = value.includes('target')
          ? `${value}&lang=${locale}`
          : `${value}?lang=${locale}`;
        value = encodeURIComponent(updatedRedirectUrl);
      }
    }
    if (AUTHORIZE_PARAMS.includes(key)) {
      authorizeUrl =
        authorizeUrl.length > 0
          ? `${authorizeUrl}&${key}=${value}`
          : `${key}=${value}`;
    }
  });
  // Condition to Display the toast message and verify email page
  // appon changing the language.
  if (
    !isSource &&
    templateType === VERIFY_EMAIL &&
    (message === ACCESS_EXPIRED ||
      message === URL_EXPIRED ||
      message === NOT_VERIFIED)
  ) {
    authorizeUrl = `${authorizeUrl}&message=${message}`;
  }
  authorizeUrl = searchParams.has('lang')
    ? authorizeUrl
    : `lang=${locale}&${authorizeUrl}`;

  if (isConsole) {
    return `${process.env.REACT_APP_CONSOLE_AUTH0_API_ENV}/auth/authorize?${authorizeUrl}`;
  }
  
  return `${process.env.REACT_APP_AUTH0_API_ENV}/sm/api/user/authorize?${authorizeUrl}`;
};
export {
  isEmpty,
  isNull,
  getRoute,
  gtmEventTracker,
  factorEventTracker,
  getAuthorizeUrl
};
